export default "__VITE_ASSET__BVueuamd__"